var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18 0L18 18L0 18L0 0Z",
    id: "Path",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3725 6.5925L6 7.092L6 9.75L4.5 9.75L4.5 6.0375L4.51125 6.0375L8.46225 4.599C8.64525 4.52925 8.84475 4.494 9.04875 4.50075C9.88431 4.52159 10.6149 5.06948 10.869 5.86575C11.0085 6.303 11.136 6.5985 11.2515 6.75225C11.9592 7.696 13.0704 8.251 14.25 8.25L14.25 9.75C12.6817 9.75171 11.195 9.05077 10.1985 7.83975L9.67575 10.8068L11.25 12.1275L11.25 17.25L9.75 17.25L9.75 12.8265L8.0475 11.3985L7.50225 14.4937L2.33175 13.5825L2.59275 12.105L6.28575 12.756L7.3725 6.5925ZM10.125 4.125C9.29657 4.125 8.625 3.45343 8.625 2.625C8.625 1.79657 9.29657 1.125 10.125 1.125C10.9534 1.125 11.625 1.79657 11.625 2.625C11.625 3.45343 10.9534 4.125 10.125 4.125Z",
    id: "Shape",
    fill: "#7E6DD6",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetType);
export default __webpack_public_path__ + "static/media/met-type.da14c7f95ff60802ee7ef0e8cc37a7ba.svg";
export { ForwardRef as ReactComponent };